export default __webpack_public_path__ + "static/media/Google-icon.a4d1f6a3.svg";